import Vue from 'vue'
import Vuex from 'vuex'
// import $tool from "../assets/js/commonFunction";
Vue.use(Vuex);


const store = new Vuex.Store({
  state: {
     header : false ,       // true 显示header背景色 ,
     footer : true ,
     hidefooter :false,
  },
  mutations: {
      change_header (state , is_show) {
          state.header = is_show;
      } ,

      change_footer (state , is_show) {
        state.footer = is_show;
      } ,

      isShow_footer (state , is_show) {
         state.hidefooter = is_show;
      } ,
  },
  actions: {

  },
  getters: {

  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js